module.exports = __webpack_public_path__ + "img/logo_retina.2b88c31c.png";